import * as Actions from '../actions/place.actions'
import * as R from 'ramda'

const initialState = { isLoading: false }

export default function (state = initialState, action) {
  switch (action.type) {
    case Actions.SET_PLACE: {
      return { ...state, ...action.place }
    }
    case Actions.DISMISS_PLACE_MESSAGE: {
      return {
        ...state,
        messages: state.messages.slice(0, state.messages.length - 1),
      }
    }
    case Actions.DISMISS_PLACE_ALL_MESSAGES: {
      return {
        ...state,
        messages: [],
      }
    }
    case Actions.UPDATE_PLACE_INFO: {
      return R.set(R.lensPath(['info', action.field]), action.value)(state)
    }
    case Actions.START_LOADING: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case Actions.END_LOADING: {
      return {
        ...state,
        isLoading: false,
      }
    }
    case Actions.UPDATE_PLACE_CONTACT_DETAIL: {
      return {
        ...state,
        ...R.pick(['newEmail'], action.values),
        info: {
          ...state.info,
          ...R.pick(
            [
              'address',
              'countryCode',
              'phoneNumber',
              'contactUrl',
              'latitude',
              'longitude',
            ],
            action.values,
          ),
        },
        email: R.ifElse(
          R.isNil,
          R.always(state.email),
          R.identity,
        )(action.values.email),
      }
    }
    case Actions.UPDATE_PLACE_BY_PROP: {
      return R.set(R.lensProp(action.field), action.value)(state)
    }
    case Actions.UPDATE_INTERESTED_BEACON: {
      return R.set(R.lensPath(['interested', 'beacon']), action.value, state)
    }
    case Actions.UPDATE_TOGGLE_LANDING: {
      return {
        ...state,
        curatedInfo: {
          ...state.curatedInfo,
          isLandingShow: action.value,
        },
      }
    }
    case Actions.UPDATE_LANDING_CREATED: {
      return {
        ...state,
        curatedInfo: {
          ...state.curatedInfo,
          isLandingCreated: action.value,
        },
      }
    }
    case Actions.UPDATE_LANDING_PLACE_NAME: {
      return {
        ...state,
        curatedInfo: {
          ...state.curatedInfo,
          alias: action.value,
        },
      }
    }
    default: {
      return state
    }
  }
}
